import { MyExtendAuthentication } from './myextend-authentication'

export default MyExtendAuthentication
